import { Component, OnInit, OnDestroy, Output, EventEmitter, ViewChildren, Input, ElementRef, QueryList } from '@angular/core';
import { CorrectionModel, DataCorrectionInstance, DataCorrectionInstanceStatus } from '../../../models/dataCorrection/dataCorrection.model';
import { DataCorrectionService } from '../../../services/dataCorrection.service';
import { tap, mergeMap, map } from "rxjs/operators";
import { Subscription, of } from 'rxjs';
import { LunaEntity } from '../../../builder/models/entity.model';
import { LoaderService } from '../../../common/services/loader.service';
import { finalize } from 'rxjs/operators';
import { EntityBuilderService } from '../../../builder/services/entity-builder.service';
import { ActivatedRoute, Router } from '@angular/router';
import { deepClone } from '../../../builder/models/editor.model';
import { DialogButton, Dialog } from '../../../core/models/dialog.model';
import { DynamicDialogService } from '../../../core/services/dynamic-dialog.service';
import { AuthService } from '../../../services/auth.service';

@Component({
    selector: 'data-correction-item-selector',
    templateUrl: './data-correction-item-selector.component.html',
    styleUrls: ['./data-correction-item-selector.component.scss'],
    standalone: false
})

export class DataCorrectionItemSelectorComponent implements OnInit, OnDestroy {

    workOrderId: string = null;
    isInReviewMode: boolean = false;
    subscriptions = new Subscription();
    entity: LunaEntity = null;
    dataList: CorrectionModel[] = [];
    dataModel: EventEmitter<CorrectionModel[]> = new EventEmitter();
    existingDataCorrectionInstanceEmitter: EventEmitter<DataCorrectionInstance> = new EventEmitter();
    entityTypes: LunaEntity[];
    dataCorrectionInstanceId: string = '';
    existingDataCorrectionInstance: DataCorrectionInstance = {
        id: "",
        entityReviewGroupId: "",
        createdDate: {},
        lastModifiedDate: {},
        submittedDate: {},
        approvedDate: {},
        deniedDate: {},
        status: DataCorrectionInstanceStatus.NotSubmitted,
        uploadedFiles: []
    };

    unAuthorizedDialog: Dialog = new Dialog("You do not have the necessary permissions to view this application in its current state.", [new DialogButton("OK", true, () => this.onUnauthorizedClick())]);

    constructor(public dataCorrectionSrv: DataCorrectionService, private readonly loader: LoaderService, private entityBuilderService: EntityBuilderService,
                private authService: AuthService, private _route: ActivatedRoute, private _router: Router, private _dialogService: DynamicDialogService) {
    }

    ngOnInit() {
        this.loader.toggleLoader(true, "Loading the list of possible Item Types...");
        let entities$ = this.entityBuilderService.getActive().pipe(tap((entities) => {
            //Filter the entities to the ones with a review group defined.
            this.entityTypes = entities.filter(a => a.adminCorrectionGroupId !== null && a.adminCorrectionGroupId !== undefined);
           
        }),
        mergeMap((result) => {
            return this._route.params.pipe(tap((params) => {
                if (params["id"]) {
                    this.dataCorrectionInstanceId = params["id"];
                }

                if (params["workOrderId"]) {
                    this.workOrderId = params["workOrderId"];
                }
            }),
                mergeMap(params => {
                    if (this.dataCorrectionInstanceId) {
                        return this.dataCorrectionSrv.getDataCorrectionInstance(this.dataCorrectionInstanceId).pipe(tap((correctionInstance) => {
                            //If there's an existing item, and we've fetched the entities, set the selected entity to the one matching the Id
                            if (correctionInstance && this.entityTypes && this.entityTypes.length > 0) {
                                this.existingDataCorrectionInstance = correctionInstance;
                                this.isInReviewMode = this.existingDataCorrectionInstance.status !== DataCorrectionInstanceStatus.NotSubmitted
                                    && this.existingDataCorrectionInstance.status !== DataCorrectionInstanceStatus.ReturnedForCorrections;

                                //If we're in review mode and the current user isn't part of review group, kick them out, unless we were provided a workOrderId.
                                //ALso, if we're not in a review state and the user differs from creator
                                if ((this.isInReviewMode && !(this.authService.User.groups.some(a => a == this.existingDataCorrectionInstance.entityReviewGroupId) || this.workOrderId))
                                    || (!this.isInReviewMode && this.authService.User.id != this.existingDataCorrectionInstance.createdDate.userId)) {
                                    this.unAuthorizedDialog.toggleDialog(true);
                                    this._dialogService.updateDialog(this.unAuthorizedDialog);
                                }
                                else {
                                    this.existingDataCorrectionInstanceEmitter.emit(this.existingDataCorrectionInstance);
                                    this.setSelectedEntity(correctionInstance.entityId);

                                    //Generate the correction list off existing Items, updated controls
                                    this.dataList = this.dataCorrectionSrv.generateCorrectionMap(correctionInstance, this.entity, this.existingDataCorrectionInstance.updatedObject, 0);
                                    this.dataModel.emit(this.dataList);
                                }
                            }
                        }));
                    }
                    else {
                        return of(this.existingDataCorrectionInstance);
                    }
            }));
        }))
        .subscribe((results) => {
                this.loader.toggleLoader(false);
        },
        (error) => {
            console.log("An error has occurred when trying to fetch active entities.");
            console.log(error);
            this.loader.toggleLoader(false);
        });

        this.subscriptions.add(entities$);        

    }

    onUnauthorizedClick() {
        this._router.navigate(["/dashboard/view/ricsDashboard"]);
    };

    ngOnDestroy() {
        if (this.subscriptions) this.subscriptions.unsubscribe();
    }

    setCollectionType(event: any): void {
        this.setSelectedEntity(event.target.selectedOptions[0].value);
    }
    
    setSelectedEntity(entityId: string): void {
        let matchingEntities = this.entityTypes.filter(a => a.id == entityId);
        if (matchingEntities.length > 0) {
            this.entity = matchingEntities[0];
            this.existingDataCorrectionInstance.entityCollectionName = this.entity.collectionName;
            this.existingDataCorrectionInstance.entityPartitionKeyValue = this.entity.partitionKeyValue;
            this.existingDataCorrectionInstance.entityId = this.entity.id;
            this.existingDataCorrectionInstance.entityReviewGroupId = this.entity.adminCorrectionGroupId;
            this.existingDataCorrectionInstanceEmitter.emit(this.existingDataCorrectionInstance);
        }
    }

    getData(): void {
        this.loader.toggleLoader(true);
        var obj$ = this.dataCorrectionSrv.getObjectToCorrect(this.existingDataCorrectionInstance.entityCollectionName, this.existingDataCorrectionInstance.entityPartitionKeyValue, this.existingDataCorrectionInstance.objectId)
            .pipe(finalize(() => {
                this.subscriptions.add(obj$);
                this.dataModel.emit(this.dataList);
                this.loader.toggleLoader(false);
            }))
			.subscribe(result => {
				console.log('result of getobjecttocorrect', result);
                this.existingDataCorrectionInstance.originalObject = deepClone(result);
                this.existingDataCorrectionInstance.updatedObject = deepClone(result);
                this.existingDataCorrectionInstanceEmitter.emit(this.existingDataCorrectionInstance);
                this.getObjectToCorrectData();

            }, (error => {
                this.loader.toggleLoader(false);
                console.log('error retrieving object record.');
            }));

    }

    getObjectToCorrectData(): void {
		this.dataList = this.dataCorrectionSrv.generateCorrectionMap(this.existingDataCorrectionInstance, this.entity, this.existingDataCorrectionInstance.updatedObject, 0);
    }

}
